export default {
  state: {
    map: {
      polygons: []
    }
  },
  mutations: {
    setPolygon (state, value) { state.map.polygons = value },
    removePolygon (state, value) {
      let result = []

      for (let i = 0; i < state.map.polygons.length; i++) {
        let item = state.map.polygons[i]
        if (item.id === value) {
          continue
        }
        result.push(item)
      }
      state.map.polygons = result
    },
    clearPolygons (state) { state.map.polygons = [] }
  }
}



// WEBPACK FOOTER //
// ./src/store/geofences/geofence-map.js